import { Stack, Typography } from "@mui/material";
import { ButtonLink } from "Components/Shared/ButtonLink";
import type { MooneLiteCta } from "Hooks/useMooneLiteCta";

type Props = {
  message: string;
  /** Where to send the viewer to lift the restriction; absent when it is not theirs to lift. */
  cta?: MooneLiteCta;
};

/**
 * What the payment menu shows instead of its actions when a chat payment is not possible: the
 * viewer's own Lite tier (with the CTA that completes their registration), or a Lite counterpart.
 */
export const ChatPaymentRestrictionNotice = ({ message, cta }: Props) => (
  <Stack gap={2} p={3} maxWidth={320}>
    <Typography color="text.secondary">{message}</Typography>
    {cta && (
      <ButtonLink
        color="primary"
        variant="contained"
        link={cta.link}
        text={cta.text}
      />
    )}
  </Stack>
);
